import { useState } from "react";
import DeleteModal from "../../component/modal/DeleteModal";
import Table from "../../component/table/Table";
import Text from "../../component/text/Text";
import { formatWithOrdinal } from "../../config/utilities/fDate";

const headers = [
  { key: "name", name: "Trip Name" },
  { key: "tripType", name: "Trip Type" },
  { key: "startTime", name: "Start Time" },
  { key: "driver", name: "Driver" },
  { key: "assistant", name: "Assistant" },
  { key: "vehicle", name: "Vehicle" },
  { key: "totalStudents", name: "No of Students" },
  { key: "status", name: "Status" },
];

export default function DailyView({
  tableData,
  handleDelete,
  loading,
  setAction,
  showDeleteModal,
  setShowDeleteModal,
  selectedRowData,
  setSelectedRowData,
  searchTerm,
  setSearchTerm,
  tableHeight = "75vh",
  selectedDate,
}) {
  const [isMobileViewport] = useState(
    typeof window !== "undefined" ? window.innerWidth <= 768 : false,
  );

  const mobileDateLabel = selectedDate
    ? `${formatWithOrdinal(selectedDate)}`
    : "Daily Schedule";

  const handlePopoverAction = (action, rowId) => {
    const selectedRow = tableData.find((row) => row._id === rowId);
    if (action === "edit") {
      setSelectedRowData(selectedRow);
      setAction("edit");
    } else if (action === "delete") {
      setSelectedRowData(selectedRow);
      setShowDeleteModal(true);
    } else {
      setSelectedRowData(selectedRow);
      setAction("view");
    }
  };

  return (
    <>
      {isMobileViewport && (
        <div className="scheduling-mobile-daily-title">
          <Text
            text={mobileDateLabel}
            size="1rem"
            weight="600"
            color="#101828"
            align="center"
          />
        </div>
      )}
      <div className="scheduling-mobile-daily-table-wrap">
        <Table
          data={tableData || []}
          searchText="Search by trip or student name..."
          headers={headers}
          showEmptyHeader={true}
          showFilter={false}
          showSearchBar={true}
          handlePopoverAction={handlePopoverAction}
          module="scheduling"
          loading={loading}
          showTableAction={false}
          height={tableHeight}
          totalRecords={tableData?.length || 0}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
        />
      </div>
      <DeleteModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
        itemName={selectedRowData}
        module="scheduling"
        loading={loading}
      />
    </>
  );
}
